import { useDispatch, useSelector } from '@redux';
import crudActions from '@redux/crudActions';
import crudSelectors from '@redux/crudSelectors';
import { createOrderBatches } from '@redux/orderBatches/actions';
import { AutoComplete, Button, Form, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DynamicObjectType } from 'types/commons';
import ConfirmModal from './Modal/ConfirmModal';
import { debounce } from 'lodash';

const BATCH_QUANTITY = [
  {
    value: 25,
  },
  {
    value: 50,
  },
  {
    value: 75,
  },
  {
    value: 100,
  },
];

const ButtonCreateBatch = ({ listReft }) => {
  const total = useSelector<number>(
    crudSelectors['ordersReadyToPick'].getTotal,
  );
  const listIds = useSelector<{ id: string }[]>(
    crudSelectors['ordersReadyToPick'].getDataArr,
  );

  const [form] = Form.useForm();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const dispatch = useDispatch();

  // const resourceFilter = useSelector<DynamicObjectType>(
  //   crudSelectors.ordersReadyToPick.getFilters,
  // );
  const selectedRowKeys = useSelector<any[]>(
    crudSelectors.ordersReadyToPick.getSelectedRowKeys,
  );

  const [loading, setLoading] = useState<boolean>(false);

  // const requestParams = useMemo(() => {
  //   return convertRequestParams('GET_ALL', {
  //     ...(selectedRowKeys?.length > 0
  //       ? {
  //           ids: selectedRowKeys.join(','),
  //           limit: selectedRowKeys?.length,
  //           offset: 0,
  //         }
  //       : {
  //           limit: resourceFilter?.pageSize,
  //           offset: resourceFilter?.pageSize * (resourceFilter?.page - 1),
  //           ...resourceFilter,
  //         }),
  //   });
  // }, [resourceFilter, selectedRowKeys]);

  const handleBatch = () => {
    setLoading(true);
    dispatch(
      createOrderBatches({
        data: {
          orderIds: selectedRowKeys,
        },
        options: {
          customApiResource: `order-batches/create/manual`,
          moveToFirst: true,
        },
      }),
    ).then((res: DynamicObjectType) => {
      setLoading(false);
      dispatch(
        crudActions.modal.toogleModal({
          ['confirmCreateBath']: {
            isOpen: false,
          },
        } as any),
      );
      dispatch(crudActions.ordersReadyToPick.setSelectedRowKeys([] as any));
      if (!res?.payload?.error)
        navigate(`/order-management?status=PROCESSING&statusOms=PICKING`);
    });
  };

  const openModal = () => {
    dispatch(
      crudActions.modal.toogleModal({
        ['confirmCreateBath']: {
          isOpen: true,
        },
      } as any),
    );
  };

  const handleSelectOrderBatch = (e) => {
    if (Number(e) > total) {
      return;
    } else if (Number(e) <= total) {
      const data = listIds
        .slice(0, Number(e))
        ?.map((item: { id: string }) => item?.id);
      listReft?.current?.handleSelectRows(data);
      dispatch(crudActions.ordersReadyToPick.setSelectedRowKeys(data as any));
    }
  };

  const onChangeDebounce = debounce((value) => {
    handleSelectOrderBatch(value);
  }, 300);

  useEffect(() => {
    if (total || selectedRowKeys?.length) {
      form.setFieldsValue({
        quantity: selectedRowKeys?.length || 0,
      });
    }
    // eslint-disable-next-line
  }, [total, selectedRowKeys?.length]);

  return (
    <>
      <Form form={form} onFinish={handleBatch}>
        <div className="flex items-center justify-end mb-5">
          <Space size={14} align="center">
            <div className="flex items-center py-[5px] pl-2.5 pr-[5px] border rounded-[5px] border-[#EFEFEF] bg-[#FFFFFF]">
              <div className="mr-2.5 text-[#2C3546] font-[500px]">
                Orders per batch
              </div>
              <Form.Item
                name="quantity"
                // noStyle
                normalize={(e) => Number(e)}
                style={{ marginBottom: 0 }}
                rules={[
                  {
                    type: 'number',
                    message: t('orders.batch.number'),
                  },
                  () => ({
                    validator(_, value) {
                      if (value <= total) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error(t('orders.batch.max', { max: total })),
                      );
                    },
                  }),
                ]}
              >
                <AutoComplete
                  style={{
                    minWidth: 60,
                    height: 'auto',
                    borderColor: '#6852D3',
                    color: '#6852D3',
                  }}
                  options={[...BATCH_QUANTITY, { value: total }]}
                  // disabled={!total || selectedRowKeys?.length > 0}
                  onChange={(e) => {
                    onChangeDebounce(e);
                  }}
                />
              </Form.Item>
            </div>
            <Button
              className="btn-primary"
              type="primary"
              disabled={total <= 0 || selectedRowKeys?.length <= 0}
              onClick={openModal}
            >
              {t('orders.createBatch')}
            </Button>
          </Space>
        </div>
      </Form>
      <ConfirmModal
        onCancel={() =>
          dispatch(
            crudActions.modal.toogleModal({
              ['confirmCreateBath']: {
                isOpen: false,
              },
            } as any),
          )
        }
        handleSubmit={form.submit}
        loading={loading}
      />
    </>
  );
};

export default ButtonCreateBatch;
